import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';

export default function FavoritesLoader() {
  const { i18n } = useTranslation('app');
  const locale = i18n.language;

  return (
    <div className="flex flex-col gap-2x">
      {Array.from({ length: 4 }).map((_, index) => (
        <div
          key={`saved-property-loader-${index}`}
          className="flex flex-col md:flex-row md:h-[238px] rounded-[16px] border border-gray bg-white overflow-hidden"
        >
          <div
            className={`${locale === 'en' ? 'md:!rounded-tr-none' : 'md:!rounded-tl-none'} relative md:w-[308px] h-[192px] md:h-full bg-gray_light_1 rounded-ss-[16px] rounded-se-[16px] md:rounded-t-0 md:rounded-s-[16px]`}
          />
          <div className="flex flex-1 flex-col gap-2x p-2x">
            <div className="flex flex-col gap-x">
              <Skeleton width="30%" height={24} borderRadius={14} />
              <Skeleton width="40%" height={24} borderRadius={14} />
            </div>
            <div className="flex flex-col gap-x">
              <Skeleton width="55%" height={24} borderRadius={14} />
              <Skeleton width="48%" height={24} borderRadius={14} />
            </div>
            <Skeleton width="100%" height={40} borderRadius={14} />
          </div>
        </div>
      ))}
    </div>
  );
}
